"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = markActivity;
exports.MARK_ACTIVITY = void 0;
var MARK_ACTIVITY = 'WEB_CHAT/MARK_ACTIVITY';
exports.MARK_ACTIVITY = MARK_ACTIVITY;

function markActivity(_ref, name, value) {
  var activityID = _ref.id;
  return {
    type: MARK_ACTIVITY,
    payload: {
      activityID: activityID,
      name: name,
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL21hcmtBY3Rpdml0eS5qcyJdLCJuYW1lcyI6WyJNQVJLX0FDVElWSVRZIiwibWFya0FjdGl2aXR5IiwibmFtZSIsInZhbHVlIiwiYWN0aXZpdHlJRCIsImlkIiwidHlwZSIsInBheWxvYWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxhQUFhLEdBQUcsd0JBQXRCOzs7QUFFZSxTQUFTQyxZQUFULE9BQTBDQyxJQUExQyxFQUFnREMsS0FBaEQsRUFBdUQ7QUFBQSxNQUEzQkMsVUFBMkIsUUFBL0JDLEVBQStCO0FBQ3BFLFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFTixhQUREO0FBRUxPLElBQUFBLE9BQU8sRUFBRTtBQUNQSCxNQUFBQSxVQUFVLEVBQVZBLFVBRE87QUFFUEYsTUFBQUEsSUFBSSxFQUFKQSxJQUZPO0FBR1BDLE1BQUFBLEtBQUssRUFBTEE7QUFITztBQUZKLEdBQVA7QUFRRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IE1BUktfQUNUSVZJVFkgPSAnV0VCX0NIQVQvTUFSS19BQ1RJVklUWSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIG1hcmtBY3Rpdml0eSh7IGlkOiBhY3Rpdml0eUlEIH0sIG5hbWUsIHZhbHVlKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogTUFSS19BQ1RJVklUWSxcbiAgICBwYXlsb2FkOiB7XG4gICAgICBhY3Rpdml0eUlELFxuICAgICAgbmFtZSxcbiAgICAgIHZhbHVlXG4gICAgfVxuICB9O1xufVxuXG5leHBvcnQgeyBNQVJLX0FDVElWSVRZIH07XG4iXX0=